import { gql } from '@apollo/client';

export const ItsMaintenanceWindow = gql`
  fragment ItsMaintenanceWindow on ItsMaintenanceWindow {
    id
    startDate
    endDate
  }
`;
